export const isEmpty = (str: string): boolean => !!str

export const isValidUsername = (str: string) => ['admin', 'editor'].indexOf(str.trim()) >= 0

export const isExternal = (path: string) => /^(https?:|mailto:|tel:)/.test(path)

export const isArray = (arg: any) => {
  if (typeof Array.isArray === 'undefined') {
    return Object.prototype.toString.call(arg) === '[object Array]'
  }
  return Array.isArray(arg)
}

export const isValidURL = (url: string) => {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

export const isVaildPass = (pass: string) => {
  const reg = /^(?=.*?[0-9])(?=.*?[a-z])[0-9a-z]{8,}$/
  return reg.test(pass)
}

export const isVaildTel = (tel: string) => {
  const reg = /^1[3-9]\d{9}$/
  return reg.test(tel)
}

export const twoDecimal = (str: string) => {
  const reg = /^[+-]?(0|([1-9]\d*))(\.\d{0,2})?$/g
  return reg.test(str)
}
